import { type ReactNode, useLayoutEffect } from 'react';
import { useStatsigClient } from '@statsig/react-bindings';

import { LoaderPage } from '@utilities';

interface StatsigLoadingBoundaryProps {
  children: ReactNode;
  isVisible?: boolean;
  onLoadingChange?: (isLoading: boolean) => void;
}

const StatsigLoadingBoundary = ({
  children,
  isVisible = true,
  onLoadingChange,
}: StatsigLoadingBoundaryProps) => {
  const { isLoading } = useStatsigClient();

  useLayoutEffect(() => {
    onLoadingChange?.(isLoading);
  }, [isLoading, onLoadingChange]);

  if (!isVisible) {
    return null;
  }

  return isLoading ? <LoaderPage /> : children;
};

export default StatsigLoadingBoundary;
